import React, { useEffect, useRef, useState } from 'react';
import { Card, Form, Input, Row, Col, Button, Table, Tooltip, Popconfirm, message, Select } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import Papa from 'papaparse'
import * as XLSX from 'xlsx';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { FileExcelFilled ,EditOutlined,CheckCircleOutlined,PlusOutlined,CloseCircleOutlined} from "@ant-design/icons";
import { Excel } from "antd-table-saveas-excel";
import { FixedComponentsCategoryEnum, FixedComponentsRateChartRequest, GlobalPriceChartRequest } from '@gtpl/shared-models/masters';
import { FixedComponentsRateChartService } from '@gtpl/shared-services/masters';
import { PackingCategoryEnum } from '@gtpl/shared-models/common-models';
/* eslint-disable-next-line */
import Highlighter from 'react-highlight-words';
import {SearchOutlined } from '@ant-design/icons';


export function FixedComponentsRateChartForm(
) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [data, setData] = useState([]);
  const [editableRow, setEditableRow] = useState('');
  const [editedData, setEditedData] = useState<any>({});
  const [isSaveButtonDisabled, setSaveButtonDisabled] = useState(false); // New state
  const { Option } = Select;
  const [searchText, setSearchText] = useState("");
const [searchedColumn, setSearchedColumn] = useState("");
const searchInput = useRef(null);


  const service = new FixedComponentsRateChartService()
  useEffect(()=>{
    getAllComponents()
  },[])
  const getAllComponents=() =>{
  service.getAllFixedComponentsRateChartInfo().then(res=>{
    if(res.status){
      setData(res.data)
    }else{
      setData([])
    }
  })
  }
  const edit = (record: any) => {
    if (editedData.component === '' || editedData.price === ''|| editedData.category === '') {
      const errorMessage = `${editedData.component === '' ? editedData.price === '' ? 'Component' : 'Price':'Category'} field is required.`;
      message.error(errorMessage, 2);
    } else {
      setEditableRow(record.id);
      setEditedData(record);
    }
  };
  const cancel = () => {
    if (editableRow !== '') {
      setEditableRow('');
      setEditedData({});
    }
  };
  const saveData = (record) => {
    if (editedData.component === '' || editedData.price === ''|| editedData.category === '' || editedData.packingCategory === '') {
      const errorMessage = `${editedData.component === '' ? editedData.price === ''?editedData.packingCategory?'Component' : 'Price':'Category':'Packing Category'} field is required.`;
      message.error(errorMessage, 2);
    } else {
      const updatedData = { ...record, ...editedData };
      const req = new FixedComponentsRateChartRequest(updatedData.id, updatedData.component, updatedData.price, updatedData.createdUser, updatedData.updatedUser, updatedData.isActive, updatedData.versionFlag, updatedData.createdAt,updatedData.category,updatedData.packingCategory);
  
      if (record.id!== undefined) {
        service.updateFixedComponentsRateChart(req).then((res) => {
          if (res.status) {
            message.success(res.internalMessage, 2);
            getAllComponents();
            setEditableRow('');
            setEditedData({});
          } else {
            message.error(res.internalMessage, 2);
          }
        });
      } else {
        console.log(req);
        
        service.createFixedComponentsRateChart(req).then((res) => {
          if (res.status) {
            message.success(res.internalMessage, 2);
            getAllComponents();
            setEditableRow('');
            setEditedData({});
          } else {
            message.error(res.internalMessage, 2);
          }
        });
      }
    }
  };
  
  
  const create = (record)=>{
      const req = new FixedComponentsRateChartRequest(record.id,record.component,record.price,record.createdUser,record.updatedUser,record.isActive,record.versionFlag,record.createdAt,record.category,record.packingCategory);
      service.createFixedComponentsRateChart(req).then((res)=>{
        if(res.status){
          message.success(res.internalMessage, 2);
          getAllComponents()
          // setEditableRow('');
          // setEditedData({});
        } else {
          message.error(res.internalMessage, 2);
        }
      });
  };
  const isEditing = (record: any) => record.id === editableRow;
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

;
  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          size="small"
          style={{ width: 90 }}
          onClick={() => {
            handleReset(clearFilters);
            setSearchedColumn(dataIndex);
            confirm({ closeDropdown: true });
          }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        )
      ) : null,
  });

const columns : any[] = [
    {
        title: 'S No',
        key: 'sno',
        align:"center",
        width:"60px",
        responsive: ['sm'],
        render: (text, object, index) => (page - 1) * pageSize + (index + 1) + (pageSize * (page - 1))
    },
    {
      title: <div style={{ textAlign: "center" }}>Component</div>,
      dataIndex: 'component',
      sorter: (a, b) => a.component.localeCompare(b.component),
      sortDirections: ["ascend", "descend"],
      ...getColumnSearchProps('component') ,
      render: (text: string, record: any) => {
        if (isEditing(record)) {
          return (
            <Input
              value={editedData.component}
              onChange={(e) => setEditedData({ ...editedData, component: e.target.value })}
            />
          );
        }
        return text;
      }
    },
    {
      title: 'Price',
      dataIndex: 'price',
      sorter: (a, b) => a.price.localeCompare(b.price),
      sortDirections: ["ascend", "descend"],
      render: (text: string, record: any) => {
        if (isEditing(record)) {
          return (
            <Input
              value={editedData.price}
              required={true}
              onChange={(e) => setEditedData({ ...editedData, price: e.target.value })}
            />
          );
        }
        return text;
      }
    },
    {
      title: 'Category',
      dataIndex: 'category',
      sorter: (a, b) => a.category.localeCompare(b.category),
      sortDirections: ["ascend", "descend"],
      render: (text: string, record: any) => {
        if (isEditing(record)) {
       
            return (
              <Select 
              value={editedData.category} 
              placeholder='Category'
              showSearch
              allowClear
              onChange={(value) => {
                console.log("Selected category:", value); // Log the selected value
                setEditedData({ ...editedData, category: value }); // Update editedData state
              }}
            >
              {Object.values(FixedComponentsCategoryEnum).map((i) => {
                return (
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                );
              })}
            </Select>
          );
        }
        return text;
      }
    },
    {
      title: 'Packing Category',
      dataIndex: 'packingCategory',
      sorter: (a, b) => a.packingCategor-b.packingCategory,
      sortDirections: ["ascend", "descend"],
      render: (text: string, record: any) => {
        if (isEditing(record)) {
       
            return (
              <Select 
              value={editedData.packingCategory} 
              placeholder='Packing Category'
              showSearch
              allowClear
              onChange={(value) => {
                console.log("Selected Packing Category:", value); // Log the selected value
                setEditedData({ ...editedData, packingCategory: value }); // Update editedData state
              }}
            >
              <Option key={'ALL'} value={'ALL'}>ALL</Option>
              <Option key={'NOBASHI'} value={'NOBASHI'}>Nobashi</Option>
              {Object.values(PackingCategoryEnum).map((i) => {
                return (
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                );
              })}
            </Select>
          );
        }
        return text;
      }
    },
    {
      title: 'Action',
      dataIndex: 'action',
      align:'center',
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Button
              type="primary"
              icon={<CheckCircleOutlined />}
              onClick={() => saveData(record)}
              style={{ marginRight: 8 }}
            >
              Save
            </Button>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <Button icon={<CloseCircleOutlined />} type="default">Cancel</Button>
            </Popconfirm>
          </span>
        ) : (
          <Button
            disabled={editableRow !== ''}
            type="default"
            icon={<EditOutlined />}
            onClick={() => edit(record)}
          >
            Edit
          </Button>
        );
      },
    },
  
]
  return(
   <Card title='Fixed Components Rate Chart' size='small'
   headStyle={{ backgroundColor: "#69c0ff", border: 0 }} style={{textAlign:'center',color:'white'}}>
    <Table columns={columns} 
    dataSource={data}
    size='small'
    pagination={{
      pageSize:50,
      onChange(current) {
        setPage(current);
      }
    }}
    bordered 
 />
  <Button
            type="primary"
            style={{ marginBottom: 16 }}
            onClick={() => {
              const newData = {
                id: undefined,
                component: '',
                price: '',
              };
              setData([...data, newData]);
              edit(newData);
            }}
          >
            <PlusOutlined /> Add Row
          </Button>
   </Card>
  )
}

export default FixedComponentsRateChartForm;
